import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { AuthState } from '@reducers/auth';

export const getAuth = (state: RootState): AuthState => state.auth;
const getAuthData = createSelector(getAuth, (auth) => auth.data);
export const getAuthError = createSelector(getAuth, (auth) => auth.error as Error);
export const getExpirationDate = createSelector(getAuthData, (data) => data.expirationDate);
export const getLoggedIn = createSelector(getAuthData, (data) => data.loggedIn);
export const getToken = createSelector(getAuthData, (data) => data.accessToken);
